import { dateUtils } from '../utils/dateUtils';

export function CurrentMonthLabel({ className = '' }: { className?: string }) {
  return (
    <span className={className}>
      <span className="font-semibold text-[var(--anl-text)]">{dateUtils.currentMonthName()}</span>
      <span className="ml-1 text-[10px] tracking-wide text-[var(--anl-text-muted)]">
        (Current month)
      </span>
    </span>
  );
}
